var map = {
	"./media/badges/quality/data-quality-a-z-level-1.svg": "6420",
	"./media/badges/quality/data-quality-a-z-level-2.svg": "d710",
	"./media/badges/quality/data-quality-a-z-level-3.svg": "31a6",
	"./media/badges/quality/data-quality-music-publishers-level 1.svg": "2946",
	"./media/badges/quality/data-quality-music-publishers-level 2.svg": "7268",
	"./media/badges/quality/data-quality-music-publishers-level-3.svg": "51f1",
	"./media/badges/quality/data-quality-record-labels-level-1.svg": "fd96",
	"./media/badges/quality/data-quality-record-labels-level-2.svg": "9488",
	"./media/badges/quality/data-quality-record-labels-level-3.svg": "33e2",
	"./media/badges/users/administrator.svg": "61c2",
	"./media/badges/users/assistant.svg": "78c8",
	"./media/badges/users/contributor.svg": "690a",
	"./media/badges/users/nda-partner.svg": "101e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6646";